export const alphabets = [];
alphabets.push({
	id:'latin',
	label:"Latin",
	enabled:true,
	charset:['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'],
});

alphabets.push({
	id:'arabic',
	label:"Arabic",
	enabled:true,
	charset:['أ','ب','ج','د','ه','و','ز','ح','ط','ي','ك','ل','م','ن','ص','ع','ف','ض','ق','ر','س','ت','ث','خ','ذ','ظ', 'غ', 'ش'],
});

alphabets.push({
	id:'cyrillic',
	label:"Cyrillic",
	enabled:true,
	charset:['а','б','в','г','д','е','ж','з','и','й','к','л','м','н','о','п','р','с','т','у','ф','х','ц','ч','ш','щ', 'ь', 'ю', 'я'],
});

alphabets.push({
	id:'hebrew',
	label:"Hebrew",
	enabled:true,
	charset:['א','ב','ג','ד','ה','ו','ז','ח','ט','י','כ','ך','ל','מ','ם','נ','ן','ס','ע','פ','ף','צ','ץ','ק','ר','ש','ת'],
});

alphabets.push({
	id:'greek',
	label:"Greek",
	enabled:true,
	charset:['α','β','γ','δ','ε','ζ','η','θ','ι','κ','λ','μ','ν','ξ','ο','π','ρ','σ','ς','ϲ','τ','υ','φ','χ','ψ','ω'],
});

alphabets.push({
	id:'polski',
	label:"Polski",
	enabled:true,
	charset:['a','ą','b','c','ć','d','e','ę','f','g','h','i','j','k','l','ł','m','n','ń','o','ó','p','r','s','ś','t','u','w','y','z','ź','ż'],
});

/*
alphabets.push({
	id:'emoji',
	label:"Emoji",
	enabled:true,
	charset:['😀','😂','😍','😕','😒','😊','😏','😥','😶','😐','🙄','😵','🤐','😷','😬','😯','😮','😲','😖','😣','😢','😜','😝','😗','😘','😎','😡','😱','😨','😰'],
});

alphabets.push({
	id:'braille',
	label:"Braille",
	enabled:false,
	charset:['⠁','⠃','⠉','⠙','⠑','⠋','⠛','⠓','⠊','⠚','⠅','⠇','⠍','⠝','⠕','⠏','⠟','⠗','⠎','⠞','⠥','⠧','⠺','⠭','⠽','⠵'],
});

alphabets.push({
	id:'hierogliphic',
	label:"Hieroglyphic",
	enabled:true,
	charset:['𓄿','𓂝','𓇋','𓈇','𓅱','𓏲','𓃀','𓊪','𓆑','𓅓','𓈖','𓂋','𓍯','𓉔','𓎛','𓐍','𓄡','𓊃','𓋴','𓐚','𓏘','𓎡','𓎼','𓏏','𓎀','𓂧','𓆓','𓌻','𓊹','𓏌','𓇳','𓇯','𓋹','𓄊','𓁹','𓊨','𓉐','𓅐','𓆄','𓄤','𓄲','𓊤','𓏠','𓐝','𓇼','𓆛','𓊖','𓆎','𓄟'],
});*/

alphabets.push({
	id:'custom',
	label:"Custom alphabet",
	enabled:true,
	charset:[],
});